import React from 'react';
import OrganisationsList from './OrganisationManagement/OrganisationsList';
import { APIProvider, IAPIPackage } from '../commonUtils/APIContext';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import OrganisationHierarchy from './OrganisationManagement/OrganisationHierarchy';
// add feature level css here

interface IBMSPFeatureRequiredProps // extends IAPIPackage
{}

export const OnboardingFeature = (props: IBMSPFeatureRequiredProps) => {
  const routeMatch = useRouteMatch();
  return (
    <>
      {routeMatch ? (
        <Switch>
          <Route path={`${routeMatch.path === '/' ? '' : routeMatch.path}/`}>
            <OrganisationHierarchy />
          </Route>
        </Switch>
      ) : null}
    </>
  );
};
export default OnboardingFeature;
